import axios from 'axios';
import { handleAxiosResponseError } from './services/axiosErrorHandler';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
// The web app authenticates via the first-party Sanctum session cookie
// (httpOnly) plus the XSRF token. We no longer read or send a bearer token from
// localStorage, where any XSS could exfiltrate it (SUPPORT-663 / F-024).
window.axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

// Request interceptor to track retry count
window.axios.interceptors.request.use(
    (config) => {
        config.retryCount = config.retryCount || 0;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor: 401 redirect, one retry for network errors, toasts
window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => handleAxiosResponseError(error, window.axios)
);

window.cdnUrl = import.meta.env.VITE_DO_CDN_ENDPOINT;

// WebAuthn / Passkey support
import {
    browserSupportsWebAuthn,
    startAuthentication,
    startRegistration,
} from '@simplewebauthn/browser';

window.browserSupportsWebAuthn = browserSupportsWebAuthn;
window.startAuthentication = startAuthentication;
window.startRegistration = startRegistration;

import './echo';

export { axios };
